module.exports = __webpack_public_path__ + "img/lucky-page_1248.9068e53b.png";